<template>
  <div id="app">
    <router-view v-if="env == 'development' && login"></router-view>
    <router-view
      v-else-if="
        login ||
          $route.path == '/login' ||
          $route.path == '/nodd' ||
          $route.path.includes('/teach') ||
          $route.path.includes('/evaluation360')
      "
    ></router-view>
    <!-- <Reback v-if="$isShowFeed.showFeedEntry" /> -->
    <div style="height:0px;" id="offsetInfo"></div>
  </div>
</template>

<script>
import { rebackSth } from "@/constants/api/MYOKR_API";
import { showToast, isYach } from "@/utils/ding";
import Bus from "@/utils/bus";
// import Reback from "@/components/common/Reback/index.vue";
import commonData from "@/utils/commonData";
import loginMixin from "@/views/loginMixin.vue";
export default {
  name: "app",
  mixins: [loginMixin],
  data() {
    return {
      aniTimer: false,
      login: false,
      env: process.env.NODE_ENV
      // rebackShow: true
      // accessObj: {
      //   appkey: process.env.VUE_APP_AppKey,
      //   appsecret: process.env.VUE_APP_AppSecret
      // },
      // tokenData: {
      //   access_token: ""
      // },
      // code: ""
    };
  },
  components: {
    // Reback
  },
  async created() {
    console.log('OKR 环境变量是', process.env.NODE_ENV);
    // 本地调试 暂时关闭 loading 效果
    if (process.env.NODE_ENV == "development") {
      // this.rebackShow = false;
      document.getElementById("loading-s").style.display = "none";
    }
    // alert(window.location.search)
    // alert(window.location.search.split("&")[0].replace("?", ""),decodeURIComponent(
    //     window.location.search.split("&")[0].replace("?", "")
    //   ))
    // var searchParams = new URLSearchParams(window.location.search.split('&')[0])
    // console.log(window.location.pathname.includes("/login"))

    if (
      process.env.NODE_ENV !== "development" &&
      window.location.pathname.includes("/login")
    ) {
      if (
        window.location.search.split("&") &&
        window.location.search.split("&")[1]
      ) {
        if (
          decodeURIComponent(
            window.location.search.split("&")[1].replace("?", "")
          ).indexOf("messagelist") ||
          decodeURIComponent(
            window.location.search.split("&")[1].replace("?", "")
          ).indexOf("new360")
        ) {
          // this.rebackShow = false;
          this.$isShowFeed.showFeedEntry = false;
        }
      }
      document.getElementById("loading-s").style.display = "none";
    }

    // setTimeout(() => {
    //   this.aniTimer = true;
    //   if (
    //     !(window.dd && window.dd.pc) &&
    //     process.env.NODE_ENV == "development"
    //   ) {
    //     this.loadingSfunc(1000);
    //   }
    // }, 2000);
    // console.log(window.dd.ios, window.dd.android, window.dd.pc);
    if (
      window.location.pathname.includes("/teach") ||
      window.location.pathname.includes("/evaluation360") ||
      window.location.pathname.includes("/nodd")
    ) {
      document.getElementById("loading-s").style.display = "none";
      return;
    }
    // }else if (window.dd.pc&&!window.dd &&process.env.NODE_ENV != "development"){
    //   this.login = true;
    //  else if (
    //   !(window.dd && window.dd.pc) &&
    //   process.env.NODE_ENV != "development"
    // ) {
    //   this.$router.replace("/nodd");
    //   return;
    // }

    if (process.env.NODE_ENV == "development") {
      this.login = true;
    }
    if (!window.location.pathname.includes("/login")) {
      // console.log("congig");
      this.login = true;
      this.fetchJsConfig();
      document.getElementById("loading-s").style.display = "none";
    }
  },
  mounted() {
    Bus.$on("login", value => {
      this.login = value;
    });
    // bpit 页面响应时间
    if (window.bpit_elk_page_start_time) {
      var end_time = new Date().getTime();
      var load_time = end_time - window.bpit_elk_page_start_time;
      commonData(load_time, {
        page: "index"
      });
    }
  },
};
</script>

<style lang="scss">
/*  .v-modal{
    z-index: 0 !important;
  }*/
body {
  margin: 0px;
  padding: 0px;
  background: #f0f1f2;
  // font-family: Microsoft YaHei;
  font-family: Microsoft YaHei, PingFang SC, Helvetica Neue, Helvetica,
    Hiragino Sans GB, SimSun, sans-serif;
  font-size: 14px;
  -webkit-font-smoothing: antialiased;

  .el-breadcrumb__inner.is-link,
  .el-breadcrumb__inner a {
    font-weight: normal;
    color: #6b6b6b;
    font-size: 12px;
  }
  .el-breadcrumb__item:last-child .el-breadcrumb__inner,
  .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover,
  .el-breadcrumb__item:last-child .el-breadcrumb__inner a,
  .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover {
    // font-weight: bold;
    color: #333333;
  }
}
.scope-okr {
  color: #326fef;
  cursor: pointer;
  transition: color 0.2s;
  &:hover {
    color: #2f87e0;
    text-decoration: underline;
  }
}
.el-table--striped .el-table__body tr.el-table__row--striped td {
  background: #f9f9f9 !important;
}
.el-table th.is-leaf,
.el-table td {
  border-bottom: 1px solid #dddddd !important;
}

.el-table .cell {
  line-height: 20px !important;
}
#app {
  // position: absolute;
  top: 0px;
  bottom: 0px;
  width: 100%;
  height: 100vh;
  box-sizing: border-box;
  overflow: auto;
  // scroll-behavior: smooth;
  // user-select: none;
  // min-width: 1280px; /*px*/
}
.el-tooltip__popper {
  max-width: 800px;
  max-height: 90%;
  // overflow-y: auto;
}
.el-popover {
  background: #ffffff !important;
  border: 1px solid #e4e4e4 !important;
  box-shadow: 0 2px 4px 0 rgba(110, 110, 110, 0.5) !important;
  border-radius: 2px 0px 0px 0px 2px 2px 2px !important;
}
.el-autocomplete-suggestion li div {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.el-pagination {
  li,
  button {
    background: transparent !important;
  }
}
</style>
